<template lang='pug'>
.fpui-package-editor-translation
  h2 {{ 'fpStore.package.editor.translation.french' | translate }}
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.name' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.fr.name', @input="update('fr', 'name', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.short_description' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.fr.description', @input="update('fr', 'description', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.description' | translate }}
    .col-xs-8
      fpui-input-textarea(:value='item.i18n.fr.long_description', @input="update('fr', 'long_description', $event)")
    .clearfix

  h2 {{ 'fpStore.package.editor.translation.english' | translate }}
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.name' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.en.name', @input="update('en', 'name', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.short_description' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.en.description', @input="update('en', 'description', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.description' | translate }}
    .col-xs-8
      fpui-input-textarea(:value='item.i18n.en.long_description', @input="update('en', 'long_description', $event)")
    .clearfix

  h2 {{ 'fpStore.package.editor.translation.japanese' | translate }}
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.name' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.jp.name', @input="update('jp', 'name', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.short_description' | translate }}
    .col-xs-8
      fpui-input-text(:value='item.i18n.jp.description', @input="update('jp', 'description', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.translation.description' | translate }}
    .col-xs-8
      fpui-input-textarea(:value='item.i18n.jp.long_description', @input="update('jp', 'long_description', $event)")
    .clearfix
</template>

<script>

export default {
  props: {
    isNew: { type: Boolean, default: false },
    item: { type: Object, required: true },
    errors: { type: Object }
  },
  methods: {
    update (lang, key, value) {
      let item = {...this.item}
      this.$set(item.i18n[lang], key, value)
      this.$emit('input', item)
    }
  }
}
</script>

<style lang='less'>
  .fpui-package-editor-translation {
    .row {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    textarea {
      width: 100% !important;
      min-height: 100px;
    }
  }
</style>
